(function() {
  var TWEMOJI_OPTIONS = {
    className: 'dh-twemoji',
    folder: 'svg',
    ext: '.svg'
  };

  var IGNORED_SELECTOR = 'script, style, textarea, input, select, option, code, pre';
  var emojiPattern = /[\u00a9\u00ae\u203c\u2049\u2122\u2139\u2194-\u21aa\u231a-\u231b\u2328\u23cf\u23e9-\u23f3\u23f8-\u23fa\u24c2\u25aa-\u25ab\u25b6\u25c0\u25fb-\u25fe\u2600-\u27bf\u2934-\u2935\u2b05-\u2b55\ud83c-\udfff]/;
  var parseQueued = false;
  var observer = null;

  function hasEmoji(node) {
    return node && node.textContent && emojiPattern.test(node.textContent);
  }

  function parseNode(node) {
    if (!window.twemoji || !node || node.nodeType !== Node.ELEMENT_NODE) return;
    if (node.matches(IGNORED_SELECTOR)) return;
    if (!hasEmoji(node)) return;

    window.twemoji.parse(node, TWEMOJI_OPTIONS);
  }

  function parsePage() {
    if (!document.body) return;
    parseNode(document.body);
  }

  function queueParse() {
    if (parseQueued) return;
    parseQueued = true;

    window.requestAnimationFrame(function() {
      parseQueued = false;
      parsePage();
    });
  }

  function startObserver() {
    if (observer || !window.MutationObserver || !document.body) return;

    observer = new MutationObserver(function(mutations) {
      var shouldParse = mutations.some(function(mutation) {
        if (mutation.type === 'characterData') {
          return emojiPattern.test(mutation.target.nodeValue || '');
        }

        return Array.prototype.some.call(mutation.addedNodes, function(node) {
          return node.nodeType === Node.TEXT_NODE
            ? emojiPattern.test(node.nodeValue || '')
            : hasEmoji(node);
        });
      });

      if (shouldParse) queueParse();
    });

    observer.observe(document.body, {
      childList: true,
      characterData: true,
      subtree: true
    });
  }

  function init() {
    parsePage();
    startObserver();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function(event) {
    parseNode(event.target);
  });
})();
